/**
 * The /playbook gift page links to `/signup?kind=<slug>&src=playbook`.
 * Its slugs are marketing words; the select needs BusinessType values.
 */
const PLAYBOOK_KIND_TO_BUSINESS_TYPE: Readonly<Record<string, string>> = {
  ecommerce: 'ecommerce',
  services: 'service',
  coaching: 'coaching',
  courses: 'course',
  saas: 'saas',
  creators: 'content_creator',
};

export function businessTypeFromPlaybookKind(kind: string | null): string {
  if (!kind) return '';
  return PLAYBOOK_KIND_TO_BUSINESS_TYPE[kind] ?? '';
}
